var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscover24X16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 10C24 10 17.9955 14.1424 7 16H24V10Z",
    fill: "#F48120"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91599 6.09336H2V9.30223H2.91599C3.40023 9.30223 3.75029 9.18554 4.05951 8.93467C4.42707 8.63128 4.64294 8.1762 4.64294 7.70363C4.63711 6.75263 3.93116 6.09336 2.91599 6.09336ZM3.65111 8.50876C3.45274 8.68379 3.20187 8.76547 2.79347 8.76547H2.62427V6.64178H2.79347C3.19603 6.64178 3.44108 6.71179 3.65111 6.89849C3.86698 7.09102 3.99533 7.38857 3.99533 7.69779C3.99533 8.00701 3.86698 8.31623 3.65111 8.50876Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55306 6.09336H4.92879V9.30223H5.55306V6.09336Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08167 7.32439C6.70827 7.18437 6.59742 7.09102 6.59742 6.92182C6.59742 6.71762 6.79579 6.56593 7.06416 6.56593C7.25086 6.56593 7.40839 6.64178 7.56592 6.82848L7.89264 6.40257C7.62426 6.1692 7.30337 6.04668 6.94748 6.04668C6.38155 6.04668 5.94398 6.44341 5.94398 6.9685C5.94398 7.41191 6.14818 7.63944 6.73161 7.84948C6.97665 7.93699 7.09917 7.99534 7.16335 8.03034C7.28587 8.11202 7.35005 8.22871 7.35005 8.3629C7.35005 8.62544 7.14584 8.81798 6.8658 8.81798C6.56825 8.81798 6.32904 8.66628 6.18318 8.39207L5.78062 8.78297C6.0665 9.20887 6.41656 9.39557 6.88914 9.39557C7.53674 9.39557 7.99765 8.96383 7.99765 8.33956C8.00932 7.82031 7.79345 7.58694 7.08167 7.32439Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20192 7.70363C8.20192 8.64879 8.94288 9.37807 9.89387 9.37807C10.1622 9.37807 10.3956 9.32557 10.6757 9.19138V8.45625C10.4248 8.70713 10.2031 8.80631 9.92304 8.80631C9.29293 8.80631 8.84369 8.35124 8.84369 7.69779C8.84369 7.07936 9.3046 6.59511 9.89387 6.59511C10.1914 6.59511 10.419 6.70013 10.6757 6.95684V6.22171C10.4015 6.08169 10.1739 6.02335 9.90554 6.02335C8.96621 6.02335 8.20192 6.77014 8.20192 7.70363Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6465 8.25205L14.7888 6.09336H14.1062L15.4656 9.38391H15.804L17.1867 6.09336H16.5099L15.6465 8.25205Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4726 9.30223H19.2462V8.75964H18.0969V7.89616H19.2054V7.35357H18.0969V6.64178H19.2462V6.09336H17.4726V9.30223Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7258 7.04434C21.7258 6.4434 21.3116 6.09918 20.5881 6.09918H19.6604V9.30805H20.2847V8.01867H20.3664L21.2299 9.30805H22L20.9907 7.95449C21.4632 7.85531 21.7258 7.53442 21.7258 7.04434ZM20.4656 7.57526H20.2847V6.60093H20.4772C20.8681 6.60093 21.0782 6.76429 21.0782 7.07934C21.0782 7.40023 20.8681 7.57526 20.4656 7.57526Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.595 9.41891C13.5391 9.41891 14.3045 8.65356 14.3045 7.70945C14.3045 6.76535 13.5391 6 12.595 6C11.6509 6 10.8856 6.76535 10.8856 7.70945C10.8856 8.65356 11.6509 9.41891 12.595 9.41891Z",
    fill: "#F48120"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 15,
    rx: 1.5,
    stroke: "black",
    strokeOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover24X16);
export default __webpack_public_path__ + "static/media/discover24x16.46ada541ec93cd2b2781c64bbd169e4c.svg";
export { ForwardRef as ReactComponent };